import React from 'react';
interface EbookMockupProps {
  title: string;
  highlight?: string;
  background: string;
  className?: string;
}
/**
 * Tablet-style ebook mockup that matches the visual style of the uploaded
 * real product mockups. Used as a placeholder for bonuses that don't yet
 * have a real mockup uploaded.
 */
export function EbookMockup({
  title,
  highlight,
  background,
  className = ''
}: EbookMockupProps) {
  return <div className={`relative bg-gray-900 rounded-[10%/8%] p-[3%] shadow-xl ${className}`} data-id="element-75">
      <div className="relative w-full h-full rounded-[6%/5%] overflow-hidden bg-gray-800" data-id="element-76">
        <img src={background} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-70" data-id="element-77" />
        <div className="absolute inset-0 bg-black/40" data-id="element-78" />
        <div className="relative h-full flex flex-col items-center justify-center text-center px-2 py-3" data-id="element-79">
          <p className="text-white text-[6px] sm:text-[7px] font-semibold uppercase tracking-wider mb-1 leading-tight" data-id="element-80">
            Resultados reales
          </p>
          <h4 className="text-white font-extrabold uppercase leading-[0.95] text-[10px] sm:text-xs tracking-tight" data-id="element-81">
            {title}
          </h4>
          {highlight && <p className="text-brand-pink-400 font-extrabold uppercase text-[10px] sm:text-xs mt-1 leading-tight" data-id="element-82">
              {highlight}
            </p>}
          <p className="text-white/80 text-[5px] sm:text-[6px] uppercase tracking-widest mt-auto pt-2" data-id="element-83">
            Bienestar Digital
          </p>
        </div>
      </div>
    </div>;
}